<!-- 服务团队-预约导师弹窗  @click="maskCloseBtn"-->
<template>
  <div class='modal-mask'
       v-if='isShow'>
    <div class='modal-wrap'>
      <div class='modal-container'
           :style='{width: defaultWidth}'
           @click="closeContainerBtn">
        <h3 class='big-title'>确认预约</h3>
        <div class='forms-kind'>
          <div class='unconfirm-item'>导师：{{currMentor.mentorType && new Map(mentorRoleEnMap).get(currMentor.mentorType)}} - {{currMentor.mentorType && new Map(mentorRoleCnMap).get(currMentor.mentorType)}} - {{currMentor.mentorName}}</div>
          <div class='unconfirm-item'>预约时间：{{currMentor.menteeResultTimeStr}}（{{computedZone}}）</div>
          <div v-if='currMentor.createTrack && currMentor.createTrack.content && currMentor.createTrack.content.length > 0'>
            <div class='unconfirm-item'
                 v-for='(time, index) in currMentor.createTrack.content'
                 :key='index'>{{time.minTimeStr}} - {{time.maxTimeStr}}</div>
          </div>
          <div class='unconfirm-item'>模块：{{currMentor.module && new Map(packageModule).get(currMentor.module)}}</div>
          <div class='unconfirm-item'>预计时间：{{currMentor.predictTime}}mins</div>
          <div class='unconfirm-item'>讨论主题：{{currMentor.title}}</div>
          <div class='unconfirm-item'>其他信息：{{currMentor.otherMsg}}</div>
          <div class='unconfirm-item pad-top'>导师建议的预约时间如下，请确认：（{{computedZone}}）</div>
          <div v-if='oneTime.length > 0'>
            <div class='radio-group'
                 v-for='subItem in oneTime'
                 :key='subItem.id'
                 @click="checkOneTime(subItem)">
              <img :src='unRadio'
                   v-if='!subItem.checked' />
              <img :src='radio'
                   v-if='subItem.checked' />
              <span class='text'
                    v-if="subItem.id !== 3">{{subItem.minTimeStr}} - {{subItem.maxTimeStr}}</span>
              <span class='text'
                    v-else>{{subItem.noTime}}</span>
            </div>
          </div>
          <p class='error'>{{checkTimeError}}</p>
        </div>
        <div class='oper'>
          <Button href='javascript:void(0)'
                  @click="appointCancel"
                  class='cancel'>取消</Button>
          <Button href='javascript:void(0)'
                  @click="appointOk"
                  :loading='hasService'
                  class='ok'>确认</Button>
        </div>
        <div class='modal-close'
             @click="maskCloseBtn">
          <img :src='modalClose' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serviceService from '@/api/undergraduate/service'
import checkedPic from '@/assets/undergraduate/images/checked.png'
import modalClose from '@/assets/undergraduate/images/modal_close.png'
import radio from '@/assets/undergraduate/images/btn_radio.png'
import unRadio from '@/assets/undergraduate/images/btn_unradio.png'
import { mentorRoleEnMap, mentorRoleCnMap, zoneCnMap2, packageModule } from '../constantsEnum'
export default {
  name: '',
  props: {
    // 当前导师
    currMentor: {
      type: Object,
      default: () => { }
    },
    isShow: {
      type: Boolean,
      default: false
    },
    defaultWidth: {
      type: String,
      default: '500px'
    }
  },
  components: {},
  data () {
    return {
      // 导师角色映射
      mentorRoleEnMap,
      mentorRoleCnMap,
      // 时区映射
      zoneCnMap2,
      // 套餐模块映射
      packageModule,
      // 选中图标
      checkedPic,
      // 关闭图标
      modalClose,
      // 单选选中图片
      radio,
      // 单选未选中图片
      unRadio,
      // 当前时间
      oneTime: [],
      formValidate: {
        checkOne: ['', '']
      },
      cancel: false,
      checkTimeError: '',
      // loading, 避免重复提交
      hasService: false
    }
  },
  computed: {
    computedZone () {
      return this.currMentor.menteeZone ? new Map(zoneCnMap2).get(this.currMentor.menteeZone) : ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      let mentor = this.currMentor.track.content
      this.oneTime = mentor.map((item, index) => {
        item.id = index
        item.checked = false
        return item
      })
      this.oneTime.push({
        id: 3,
        checked: false,
        noTime: '以上时间均不合适，撤销本次预约'
      })
    })
  },
  methods: {
    // 遮罩层点击关闭
    maskCloseBtn () {
      this.resetState()
      this.$emit('closeModal')
    },
    // 阻止冒泡
    closeContainerBtn (e) {
      e.stopPropagation()
      return false
    },
    // 选一个时间-change切换
    checkOneTime (items) {
      let onTime = this.oneTime
      this.oneTime = onTime.map(item => {
        if (item.id === items.id) {
          item.checked = true
          if (items.id === 3) {
            this.formValidate.checkOne = ['', '']
            this.cancel = true
          } else {
            this.formValidate.checkOne = [items.minTimeStr, items.maxTimeStr]
            this.cancel = false
          }
        } else {
          item.checked = false
        }
        return item
      })
      this.checkTimeError = ''
    },
    // 确认弹窗的确认操作
    appointOk () {
      if (this.checkValid()) {
        this.hasService = true
        // 判断学生是否撤销逻辑
        let data = {
          mentorId: this.currMentor.mentorId,
          cancel: this.cancel,
          ugdAppointmentTimeId: this.currMentor.id,
          menteeZone: this.currMentor.menteeZone,
          resultTimeStr: this.formValidate.checkOne[0]
        }

        // 调用接口
        serviceService.appointComfirmMenteeSub(data).then(res => {
          this.$ugd_message('操作成功', 'success')
          this.hasService = false

          this.$emit('appointModalOk', data)
        }).catch(error => {
          this.$ugd_message(error.message, 'error')
          this.hasService = false
        })
      }
    },
    // 校验
    checkValid () {
      let isValid = true
      let idx = this.oneTime.findIndex(item => item.checked)
      if (idx === -1) {
        this.checkTimeError = '请选择预约时间'
        isValid = false
      }
      return isValid
    },
    // 确认弹窗的取消操作
    appointCancel () {
      this.maskCloseBtn()
    },
    // 重置操作
    resetState () {
      // 当前时间
      this.oneTime = []
      this.formValidate = {
        checkOne: ''
      }
      this.checkTimeError = ''
    }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(230, 234, 241, 0.7);
  z-index: 9999;
  .modal-wrap {
    position: absolute;
    top: 100px;
    bottom: 100px;
    overflow-y: scroll;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 #e6eaf1;
    .modal-container {
      background: #fff;
      padding: 30px 50px;
      position: relative;
      .big-title {
        font-size: 20px;
        color: #667483;
        letter-spacing: 0;
        text-align: center;
        font-weight: normal;
      }
      .forms-kind {
        padding-top: 40px;
        .small-title {
          padding-bottom: 10px;
          font-size: 16px;
          color: #667483;
          letter-spacing: 0;
          font-weight: normal;
        }
        .warning {
          font-size: 14px;
          line-height: 28px;
          color: #ff6020;
          letter-spacing: 0;
        }
        .radio-group {
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
          }
          .text {
            margin-left: 20px;
          }
        }
      }
      .oper {
        text-align: center;
        button {
          display: inline-block;
          font-size: 14px;
          margin: 20px;
          width: 116px;
          height: 32px;
          border-radius: 8px;
          text-align: center;
        }
        .cancel {
          border: 1px solid #b1bcc8;
          color: #b1bcc8;
        }
        .ok {
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          color: #fff;
        }
      }
      .modal-close {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 36px;
        height: 36px;
        padding: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .pad-top {
    padding-top: 20px;
  }
  .error {
    padding-left: 10px;
    line-height: 20px;
    color: #f00;
  }
}
</style>
